import React from 'react';
import { S } from './Users.style';
import { Input } from '../../components/Input';
import { createUser } from '../../traits/api/users/createUser';
import { useNavigate } from 'react-router-dom';
import { MultiSelect, Option } from '../../components/MultiSelect';
import {
  SortControls,
  useGetMyProjects,
} from '../../traits/api/projects/useGetMyProjects';
import { Checkbox } from '../../components/Checkbox';
import { useAuth } from '../../traits/hooks/useAuth';

export const NewUser = () => {
  const route = useNavigate();
  const { isCustomerAdmin } = useAuth();
  const { data: projects } = useGetMyProjects(
    0,
    SortControls.ProjectNameAsc,
    undefined,
    1000
  );

  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [hasAllProjectAccess, setHasAllProjectAccess] = React.useState(true);
  const [selectedProjects, setSelectedProjects] = React.useState<Option[]>([]);
  const [password, setPassword] = React.useState('');

  const createU = createUser();

  if (!isCustomerAdmin) {
    return <S.H6>Du har inte behörighet att se denna sida</S.H6>;
  }

  const createUserF = () => {
    createU
      .mutateAsync({
        firstName,
        lastName,
        email,
        password,
        hidden: false,
        clientIds: [],
        hasAllProjectAccess,
        projectIds: hasAllProjectAccess
          ? []
          : selectedProjects.map((p) => p.key),
      })
      .then(() => {
        setFirstName('');
        setLastName('');
        setEmail('');
        setPassword('');
        setHasAllProjectAccess(true);
        setSelectedProjects([]);
        route('/users');
      });
  };

  return (
    <>
      <S.HeaderContainer>
        <S.H3>Lägg till ny användare</S.H3>
      </S.HeaderContainer>
      <S.Form>
        <S.FormRow>
          <Input
            value={firstName}
            onChange={(ev) => {
              setFirstName(ev.target.value);
            }}
            type="text"
            placeholder="Förnamn"
          />
          <Input
            onChange={(ev) => {
              setLastName(ev.target.value);
            }}
            value={lastName}
            type="text"
            placeholder="Efternamn"
          />
        </S.FormRow>
        <S.FormRow>
          <Input
            onChange={(ev) => {
              setEmail(ev.target.value);
            }}
            value={email}
            type="text"
            placeholder="E-post"
          />
          <Input
            onChange={(ev) => {
              setPassword(ev.target.value);
            }}
            value={password}
            type="password"
            autoComplete="new-password"
            placeholder="Lösenord"
          />
        </S.FormRow>
        <S.FormRow>
          <Checkbox
            checked={!hasAllProjectAccess}
            onChange={() => {
              setHasAllProjectAccess(!hasAllProjectAccess);
              if (!hasAllProjectAccess) {
                setSelectedProjects([]);
              }
            }}
            label="Begränsa till specifika projekt"
          />
        </S.FormRow>
        {!hasAllProjectAccess && (
          <S.FormRow>
            <MultiSelect
              label="Välj vilka projekt användaren ska ha tillgång till"
              optionLabel="Välj projekt"
              searchPlaceholder="Sök projekt..."
              selectAllLabel="Alla projekt"
              chosenOptions={selectedProjects}
              setChosenOptions={setSelectedProjects}
              options={
                projects
                  ? projects.map((project) => ({
                      key: project.projectId,
                      label: project.name,
                    }))
                  : []
              }
            />
          </S.FormRow>
        )}
        <S.FormRow>
          <S.Button
            onClick={(ev) => {
              ev.preventDefault();
              createUserF();
            }}
          >
            Lägg till användare
          </S.Button>
        </S.FormRow>
      </S.Form>
    </>
  );
};
